import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthServices } from './auth.services';
import { Observable} from 'rxjs/Observable';
import * as _ from 'lodash';
import { CommonServices} from '../../services/src/api';
import {EnvUtils, RouterUtils} from '../../utils';

@Injectable()
export class ScheduleGuard implements CanActivate {
        checkURL = '/schedule/list';
    constructor(private router: Router,
                private authService: AuthServices,
                private commonServices: CommonServices) {
    }

    canActivate(): Observable<boolean> | boolean  {
        let userRole = global['userRole'];
        let option = {
            curCmpnId : global['loginUser'].curCmpnId,
            viewType : 'list'
        };

        if (userRole !== undefined) {
            const rolePrm = _.find(userRole.rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_020', 'rsrcPathVal': this.checkURL});
            const IF_ACCESSIBLE = rolePrm === undefined ? false : true;
            if (!IF_ACCESSIBLE) {
                // 라우팅 에러때문에 강제로 초기 라우팅
                location.href = location.origin + RouterUtils.makeUrl('/incident/incident', option);
            }
            return  Observable.of(IF_ACCESSIBLE);
        } else {
            const access_token = EnvUtils.envCdToAccessToken();
            return this.commonServices.getSessionMap(access_token)
                .map(rsltUserRole => {
                    userRole = rsltUserRole;

                    const rolePrm = _.find(userRole.rolePrms, {'rsrcTypeCd': 'PRMS_RSRC_020', 'rsrcPathVal': this.checkURL});
                    const IF_ACCESSIBLE = rolePrm === undefined ? false : true;

                    if (!IF_ACCESSIBLE) {
                        location.href = location.origin + RouterUtils.makeUrl('/incident/incident', option);
                    }
                    return IF_ACCESSIBLE;
                });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/authentications/src/schedule.guard.ts